import VerificationCodeBrick from './VerificationCodeBrick';
import { useDispatch, useSelector } from 'react-redux';
import FJAction from '../../action/FJAction';
import FJLocalStore from '../../store/FJLocalStore';

const VerificationCodeContainer = props => {
    const dispatch = useDispatch();
    let { popupType, stepChange, active } = props;
    const { confirmEmail } = useSelector(store => {
        return {
            confirmEmail: store.mainStore.confirmEmail,
        };
    });
    // 重发验证码(发送验证码)
    let _resendCode = (callback, stopLoad) => {
        const obj = {
            email: confirmEmail,
            type: 2,
            is_resend: 1,
            code_language: FJLocalStore.currentTag(),
        };
        dispatch(FJAction.resendCode(obj, callback, stopLoad));
    };
    // 检验 验证码
    let _codeConfirm = (code, callback) => {
        dispatch(FJAction.confirmCode(code, callback));
    };
    return (
        <VerificationCodeBrick
            value={confirmEmail}
            resendCode={_resendCode}
            confirmClick={_codeConfirm}
            stepChange={stepChange}
            popupType={popupType}
            active={active}
        />
    );
};
export default VerificationCodeContainer;
